module.exports = __webpack_public_path__ + "static/media/cutsglare_italian_00027.e799c18f.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/it/cutsglare_italian_00027.png
// module id = 458
// module chunks = 0